<template>
  <div class="container">
    <DeliveryOperationList
      v-if="step === 0"
      :routeFlag="routeFlag"
      @nexStep="nexStep"
      @confirm="confirm"
    />
    <DeliveryOperation
      v-if="step === 1"
      :productOrder="productOrder"
      @prevStep="prevStep"
      @nexStep="nexStep"
    />
  </div>
</template>

<script>
import DeliveryOperationList from './list';
import DeliveryOperation from './delivery';

export default {
  name: 'DeliveryOperationIndex',
  components: {
    DeliveryOperationList,
    DeliveryOperation,
  },
  data() {
    return {
      step: 0,
      productOrder: {},
      routeFlag: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.routeFlag = !vm.routeFlag;
    })
  },
  methods: {
    confirm(productOrder) {
      this.productOrder = productOrder;
    },
    prevStep() {
      this.step -= 1;
    },
    nexStep() {
      this.step += 1;
      this.step %= 2;
    },
  },
};
</script>

<style scoped>
  .container {
    height: 100%;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
  }
</style>
